import axios from '@/helpers/axios';
import { UploadImage } from '@/types/models/upload_image';
import { UploadedImage } from '@/types/models/uploaded_image';

export async function uploadImage(payload: UploadImage) {
  const fd = new FormData();
  fd.append('image', payload.image);
  return await axios.post<UploadedImage>('/uploads/image', fd).then(res => res.data);
}
